import './EmptyState.css'

import type { ReactNode } from 'react'

import { cx } from '../utilities/cx'

export type EmptyStateProps = {
  className?: string
  title: string
  description?: string
  actions?: ReactNode
}

export const EmptyState = (props: EmptyStateProps) => {
  const { className, title, description, actions } = props

  return (
    <div className={cx('empty-state', className)}>
      <h2 className="empty-state__title">{title}</h2>
      {description && <p className="empty-state__description">{description}</p>}
      {actions && <div className="empty-state__actions">{actions}</div>}
    </div>
  )
}
